import { createSlice } from '@reduxjs/toolkit';
import { createMicroSite, fetchMicroSites, updateMicroSite, fetchMicroSiteDetails } from '../actions/microSiteActions';

const microSiteSlice = createSlice({
  name: 'microSite',
  initialState: {
    microSites: [],
    currentSite: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle fetchMicroSites
      .addCase(fetchMicroSites.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMicroSites.fulfilled, (state, action) => {
        state.isLoading = false;
        state.microSites = action.payload;
      })
      .addCase(fetchMicroSites.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Handle createMicroSite
      .addCase(createMicroSite.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createMicroSite.fulfilled, (state, action) => {
        state.isLoading = false;
        state.microSites.unshift(action.payload);
      })
      .addCase(createMicroSite.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Handle updateMicroSite
      .addCase(updateMicroSite.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateMicroSite.fulfilled, (state, action) => {
        state.isLoading = false;
        const index = state.microSites.findIndex(site => site.id === action.payload.id);
        if (index !== -1) {
          state.microSites[index] = action.payload;
        }
      })
      .addCase(updateMicroSite.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Handle fetchMicroSiteDetails
      .addCase(fetchMicroSiteDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMicroSiteDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currentSite = action.payload;
      })
      .addCase(fetchMicroSiteDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = microSiteSlice.actions;
export default microSiteSlice.reducer; 